import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  FilterFormActions,
  FilterFormClearButton,
  FilterFormSubmitButton,
} from 'components/filters/FilterFormButtons';
import useFilterFormContextApplyFiltersStoredValues from 'components/filters/useFilterFormContextApplyFiltersStoredValues';
import useFilterFormContextFormHandlers from 'components/filters/useFilterFormContextFormHandlers';
import DateTimePickerField from 'components/forms/dateTimePickerField/DateTimePickerField';
import PropertyMultiSelectField from 'components/forms/domain/property/PropertyMultiSelectField/PropertyMultiSelectField';
import { Form } from 'components/forms/form/Form';
import CommonFiltersContainer from 'pages/automations/common/CommonFiltersContainer';
import ActionTypeMultiSelectField from 'pages/automations/triggers/filters/fields/ActionTypeMultiSelectField';
import { StyledFiltersRow } from 'components/domain/automation/common/Filters.styled';
import { AVAILABLE_FILTER_ACTIONS } from './ScheduledMessagesTabFilters.constants';
import { ScheduledMessagesTabFiltersSchemaType } from './ScheduledMessagesTabFilters.schema';
import StatusMultiSelectField from './fields/StatusMultiSelectField';
import LeadsField from './fields/LeadsField';
import MessageNameField from './fields/MessageNameField';

const ScheduledMessagesTabFilters = () => {
  const { t } = useTranslation();
  const { handleClear, handleSubmit } =
    useFilterFormContextFormHandlers<ScheduledMessagesTabFiltersSchemaType>();

  useFilterFormContextApplyFiltersStoredValues();

  return (
    <CommonFiltersContainer
      searchField={<LeadsField />}
      stateStorageKey="scheduled-messages-tab-filters-expanded"
    >
      <Form
        data-testid="scheduled-messages-tab-filters-form"
        horizontal
        onSubmit={handleSubmit}
      >
        <StyledFiltersRow>
          <Col md={4} sm={6}>
            <DateTimePickerField
              colSmInput={8}
              colSmLabel={4}
              label={t('pageAutomations.scheduledMessages.filters.from')}
              name="from"
              paddingLeft="0"
            />
          </Col>
          <Col md={4} sm={6}>
            <ActionTypeMultiSelectField
              availableActions={AVAILABLE_FILTER_ACTIONS}
              label={t('pageAutomations.scheduledMessages.filters.sentVia')}
              name="sentVia"
            />
          </Col>
          <Col md={4} sm={6}>
            <StatusMultiSelectField
              label={t('pageAutomations.scheduledMessages.filters.status')}
              name="status"
            />
          </Col>
        </StyledFiltersRow>
        <StyledFiltersRow>
          <Col md={4} sm={6}>
            <DateTimePickerField
              colSmInput={8}
              colSmLabel={4}
              label={t('pageAutomations.scheduledMessages.filters.to')}
              name="to"
            />
          </Col>
          <Col md={4} sm={6}>
            <PropertyMultiSelectField
              colSmInput={8}
              colSmLabel={4}
              enableHotels={false}
              enableUnitTypes
              isSelectAllEnabled
              label={t('pageAutomations.scheduledMessages.filters.propertyUid')}
              name="propertyUid"
              placeholder={t('common.selectOption')}
            />
          </Col>
          <Col md={4} sm={6}>
            <MessageNameField />
          </Col>
        </StyledFiltersRow>

        <FilterFormActions>
          <FilterFormClearButton onClick={handleClear} />
          <FilterFormSubmitButton />
        </FilterFormActions>
      </Form>
    </CommonFiltersContainer>
  );
};

export default ScheduledMessagesTabFilters;
